import React from "react";

const Footer = () => {
  return (
    <footer
      style={{
        backgroundColor: "#1976d2",
        color: "white",
        padding: "16px",
        textAlign: "center",
      }}
    >
      © 2025 GSM App — All rights reserved.
    </footer>
  );
};

export default Footer;
